<span class="submit-alert">
    Your order has been submitted.
  </span>
  